// 图片类页面路由

const ActivityCn = r => require.ensure(
  [],
  () => r(require('@/components/img-page/activity-cn')),
  'ActivityCn'
)
  
export default [
  {
    path: '/ImgPage/ActivityCn/:name',
    name: 'ImgPage_ActivityCn',
    component: ActivityCn
  }
]



// WEBPACK FOOTER //
// ./src/router/sub-route/img-page.js